const createType = (perfix: string) => {
    return {
        REQUEST: perfix + '_REQUEST',
        SUCCESS: perfix + '_SUCCESS',
        FAILED: perfix + '_FAILED'
    };
};

export const CHANGE_SEARCH_KEY = 'CHANGE_SEARCH_KEY';
export const GLOBAL_SEARCH_META = createType('GLOBAL_SEARCH_META');
